import { DatadogPagesRouter } from '@datadog/browser-rum-nextjs';

import { useDatadogRum } from '../monitoring/use-datadog-rum';

const DatadogRum: React.FC = () => {
  useDatadogRum();

  return <DatadogPagesRouter />;
};

export default DatadogRum;
